import * as service from "../service";

export const GetAccessTokenAPI = async (
  id: string,
  university_email: string,
) => {
  try {
    const resp = await service.call(
      "POST",
      "api/user/accessToken/getAccessToken",
      {
        id,
        university_email,
      },
    );
    if (resp.status === 0) {
      return resp.result;
    }
  } catch (err) {
    console.error(`GetAccessTokenAPI ${err}`);
  }
};